import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useTranslation } from 'react-i18next'
import { getDonutChartOptions } from 'config/highcharts'
import { sortdData } from 'utils/highcharts.utils'

Highcharts.setOptions({
  credits: { enabled: false }
})

const WorkersByGroupChart = ({ data, totalWorkers, onGroupClick = null }) => {
  const { t } = useTranslation()
  const chartData = data.map(d => {
    return {
      name: d.groupName,
      y: parseInt(d.workerCount),
      groupData: d
    }
  })
  // Center numerator = DISTINCT workers across crews (a worker who worked in two
  // crews today must not be counted twice, which summing the slices would do).
  // Falls back to the slice sum when the rows don't carry the workers arrays.
  const distinctWorkers = new Set()
  let hasWorkerArrays = false
  data.forEach(g => {
    if (Array.isArray(g.workers)) {
      hasWorkerArrays = true
      g.workers.forEach(w => { if (w?.workerId != null) distinctWorkers.add(w.workerId) })
    }
  })
  const total = hasWorkerArrays
    ? distinctWorkers.size
    : chartData.reduce((sum, item) => sum + item.y, 0)
  const max = totalWorkers

  const chartOptions = getDonutChartOptions({
    data: sortdData(chartData),
    title: t('dashboard.workersCountFraction', { total, max }),
    onPointClick: onGroupClick
  })

  return (
    <div className='w-full h-96 min-h-[600px] p-6'>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  )
}

export default WorkersByGroupChart
